import { render, staticRenderFns } from "./WizardLayout.vue?vue&type=template&id=1808f43b&scoped=true"
import script from "./WizardLayout.vue?vue&type=script&lang=js"
export * from "./WizardLayout.vue?vue&type=script&lang=js"
import style0 from "./WizardLayout.vue?vue&type=style&index=0&id=1808f43b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1808f43b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VRow,VSpacer})
